import { useMutation, useQueryClient } from '@tanstack/react-query';

import { confirmTenantJoin } from 'src/api/lib/tenant';
import { tenantKeys } from 'src/api/query-keys/tenant/tenant';

export const useConfirmTenantJoin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => confirmTenantJoin(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantKeys.all });
    },
  });
};
